import React from 'react';
import { FormGroup, ControlLabel, InputGroup, FormControl, HelpBlock } from 'react-bootstrap';
import _ from 'lodash';

/**
 * Transforms the content into HTML.
 */
const parseHTML = {
  inputGroup: (data, { formControl, icon, errors }) => (
    <InputGroup>
      {formControl}
      {data.icon && icon}
      {data.errors && errors}
    </InputGroup>
  ),
  div: (data, { formControl, errors }) => (
    <div>
      {formControl}
      {data.errors && errors}
    </div>
  ),
};

const CustomFormGroup = ({
  header = '',
  name,
  value = '',
  type = 'text',
  data = { icon: null, dirty: false, errors: [] }, // Icon can be null to remove it completely
  saveValue = () => {},
  onChange = () => {},
  onKeyPress = () => {},
  componentClass = 'input',
  selectData = [],
  selectHaveNullOption = false,
  showControlLabel = true,
  noValue = false,
  readonlyFormatter = i => i,
  ...props
}) => {
  // Validate data object
  data.icon = data.icon || null;
  data.dirty = data.dirty || false;
  data.errors = data.errors || [];

  // Add default option if needed and parse the other data into options
  let items = [];
  if (selectHaveNullOption) {
    items.push(
      <option key="default_option" value="">
        Please select
      </option>,
    );
  }
  items.push(
    ...selectData.map(option => (
      <option value={option.key} key={option.key}>
        {option.value}
      </option>
    )),
  );

  const content = {
    formControl: (
      <FormControl
        name={name}
        type={type}
        componentClass={componentClass}
        onChange={onChange}
        onKeyPress={onKeyPress}
        value={value || (noValue ? undefined : '')}
        {...props}
      >
        {componentClass === 'select' ? items : null}
      </FormControl>
    ),

    icon: (
      <InputGroup.Addon
        name={name}
        onClick={saveValue}
        className={data.dirty ? 'cursor-pointer' : 'cursor-not-allowed text-light-gray'}
      >
        <i name={name} className={`fa fa-${data.icon}`}>
          {' '}
        </i>
      </InputGroup.Addon>
    ),

    errors: data.errors.map((error, key) => <HelpBlock key={key}>{error}</HelpBlock>),
  };

  if (props.disabled && _.isObjectLike(props.placeholder)) {
    return null;
  }

  return props.disabled ? (
    <div>
      {showControlLabel && <ControlLabel className="mr-5">{header}:</ControlLabel>}
      {readonlyFormatter(props.placeholder || value) || '-'}
    </div>
  ) : (
    <FormGroup validationState={data.errors && data.errors.length ? 'error' : null}>
      {showControlLabel && <ControlLabel>{header}</ControlLabel>}
      {data.icon && parseHTML.inputGroup(data, content)}
      {!data.icon && parseHTML.div(data, content)}
    </FormGroup>
  );
};

export default CustomFormGroup;



// WEBPACK FOOTER //
// ./src/components/CustomFormGroup.js